import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@material-ui/icons";
import SimpleAddCategory from "./simpleAddCategory";

export default function SimpleAddCategoryModal({ open, handleClose, onSelect }) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box>
            <Typography variant="h6">Nueva categoría</Typography>
            <Typography variant="caption" color="text.secondary">
              Se seleccionará automáticamente al crearla
            </Typography>
          </Box>
          <IconButton size="small" onClick={handleClose}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 2 }}>
        <SimpleAddCategory onClose={handleClose} onSelect={onSelect} />
      </DialogContent>
    </Dialog>
  );
}
